export interface IPNSCredentials {
  username: string;
  password: string;
}
